import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import MetaTags from 'aurora-utils/metaTags.json';

const ADGMHelmet = ({ metaObject, metaImg, metaOuterImg, dynOne }) => {
  const [config, setConfig] = useState();
  const [lang, setLang] = useState();
  useEffect(() => {
    // set langKeys
    if (metaObject) {
      const converttostring = metaObject + `_${localStorage.getItem('lang')}`;
      setConfig(converttostring);
      setLang(localStorage.getItem('lang'));
    }
  }, []);
  const canonical = window.location.href;
  const renderItems = (tit, des) => {
    // eslint-disable-next-line prefer-const
    let title = tit;
    // eslint-disable-next-line prefer-const
    let desc = des;

    if (metaObject === 'profession' || metaObject === 'project') {
      const regex = /{s}/i;
      title = title.replace(regex, dynOne);
      desc = desc.replace(regex, dynOne);
    }
    return (
      <Helmet>
        <title>{title}</title>
        <meta name='description' content={desc} />
        <meta property='og:title' content={title} />
        <meta property='og:description' content={desc} />
        <meta property='twitter:title' content={title} />
        <meta property='twitter:description' content={desc} />
        <link rel='canonical' href={canonical} />
        <meta property='og:url' content={canonical} />
        <meta property='og:type' content='website' />
        <meta property='og:locale' content={lang === 'en' ? 'en_US' : 'ar_UAE'} />
        {metaImg && <meta property='og:image' content={`${window.location.origin + metaImg}`} />}
        {metaOuterImg && <meta property='og:image' content={metaOuterImg} />}
      </Helmet>
    );
  };
  return <>{config && renderItems(MetaTags[config]?.title, MetaTags[config]?.desc)}</>;
};

ADGMHelmet.propTypes = {
  metaObject: PropTypes.object.isRequired,
  metaImg: PropTypes.string.isRequired,
  metaOuterImg: PropTypes.string.isRequired,
  dynOne: PropTypes.string.isRequired,
};

export default ADGMHelmet;
